import { AddProduct } from "../events/AddProduct"

export const NewGroupsAccommodationsPage = () => {
  return <AddProduct type="noclegi-dla-grup" />
}

export default NewGroupsAccommodationsPage
